import router from '@ps/router'
import store from '@ps/store'
import {
  findChildByRouteIndexInScene,
  getGamePlay,
  getRouteIndexByNodeInScene,
  isUUID,
  isVPComponent,
  parseComponent,
} from '@ps/utils/game'
import qc from 'qc'
import { removeIvSegmentToScene } from '../timeline/utiles/scene'
import { isEndHotAreaNode, isIvSceneLinkNode } from '../brain/brain'
import nodePool from '@ps/bridge/qc/node-pool'
import { resolveVPName } from '@ps/store/workbench/visual-program'
import { isNormalScene } from '@ps/bridge/qc/scripts/scene-config'
import * as sceneConfigScript from '@ps/bridge/qc/scripts/scene-config'
import { getSceneNodeByNode, isVideo } from '@ps/bridge/qc/base'
import { Message } from 'element-ui'
import i18n from '@ps/lang'
import { IvLinkType } from '../brain/enums'
import { isLastNormalScene } from '../timeline/timeline'
import { emptyClipboard } from '@ps/workbench/copy-paste'
import { IvBrainItem } from '../brain/types'

export async function addTextComponent(data: any, parentNode: qc.Node) {
  const component = parseComponent(data)
  const projectKey = router.currentRoute.query.id
  const { node } = await store.dispatch('workspace/game/prefab/addNewPrefab', {
    res: {
      name: component.prefabName,
      json: component.json,
      meta: component.meta,
      projectKey: projectKey,
      files: component.files,
      uuid2url: store.state.workspace.game.uuid2url,
      type: component.type,
      animationType: component.animationType, // 用于识别龙骨类型的图集
    },
    parentNode,
    record: false,
  })
  return node
}

export function ivRemoveNode(node: qc.Node) {
  const currentSceneNode = store.state.workspace.sceneManager.currentSceneNode
  const brainData = store.state.ivBrain.brainData
  const copySegmentUuid = store.state.ivCopyPaste.copySegmentUuid
  if (node.uuid === copySegmentUuid) {
    store.commit('ivCopyPaste/updateCopySegmentUuid', null)
    emptyClipboard()
  }
  if (
    isIvSceneLinkNode(node) ||
    isEndHotAreaNode(currentSceneNode.uuid, node.uuid)
  ) {
    if (isLastNormalScene(currentSceneNode)) {
      // 最后一个视频节点允许删除场景间的互动元件，即改为自动跳转
      const brainItem = brainData.find(
        (brain) => brain.sceneUuid === currentSceneNode.uuid,
      )
      store.dispatch('ivBrain/switchIvSegment', {
        nodeUuid: brainItem.link.id,
        sceneUuid: brainItem.sceneUuid,
        interactiveType: '',
        type: IvLinkType.Auto,
        record: true,
      })
      store.dispatch('workspace/game/clearActiveNode', {
        record: false,
      })
      store.dispatch('ivTimeline/refreshTimeline')
    } else {
      Message.info(i18n.t('interactiveVideo.iv.validateTip.banRemoveHotArea'))
    }
    return
  }
  if (isVideo(node)) {
    Message.info(i18n.t('interactiveVideo.iv.validateTip.banRemoveVideo'))
    return
  }
  removeIvSegmentToScene(currentSceneNode.uuid, node.uuid)
  store.dispatch('workspace/game/removeNode', {
    nodes: [node],
  })
  store.dispatch('ivTimeline/refreshTimeline')
}
export const deepReplaceAstUUID = ({
  vpAst,
  sceneNode,
  ignoreKey,
}: {
  vpAst: any
  sceneNode: qc.Node
  ignoreKey?: any
}) => {
  const ignoreReplaceKey = ['jumpSceneId', ...(ignoreKey || [])]
  const gamePlay = getGamePlay()
  for (const key in vpAst) {
    if (
      /^\[object (Array|Object)\]$/.test(
        Object.prototype.toString.call(vpAst[key]),
      )
    ) {
      deepReplaceAstUUID({
        vpAst: vpAst[key],
        sceneNode,
        ignoreKey: ignoreKey,
      })
    }

    // 修改拷贝节点指向的UUID
    if (isUUID(vpAst[key]) && !ignoreReplaceKey.includes(key)) {
      const targetNode = nodePool.find(vpAst[key])
      // gamePlay节点不用改
      // eslint-disable-next-line
      if (!targetNode || targetNode === gamePlay) continue
      const path = getRouteIndexByNodeInScene(targetNode)
      vpAst[key] = findChildByRouteIndexInScene(sceneNode, path).uuid
    }
    // 修改拷贝节点对应的scrip字段（ps.VPComponent_xxx
    if (isVPComponent(vpAst[key])) {
      const targetNode = nodePool.find(vpAst[key])
      // gamePlay节点不用改
      // eslint-disable-next-line
      if (!targetNode || targetNode === gamePlay) continue
      const path = getRouteIndexByNodeInScene(targetNode)
      const { className } = resolveVPName(
        findChildByRouteIndexInScene(sceneNode, path),
      )
      vpAst[key] = className
    }
  }
}
// 检查是否有场景没有视频
export function eachSceneHasVideo(): boolean {
  const gamePlay = getGamePlay()
  if (!gamePlay) return false
  let res = true
  gamePlay.children.forEach((scene: qc.Node) => {
    if (isNormalScene(scene)) {
      const SceneConfig = sceneConfigScript.getScript(scene)
      if (!SceneConfig.isEnding) {
        const videoNode = scene.children.find((child) => isVideo(child))
        if (!videoNode) {
          res = false
        }
      }
    }
  })
  return res
}
// 互动视频组节点和场景节点一样的布局属性
export function ivGroupNodePos(node: qc.Node) {
  node._maxAnchor.x = node._maxAnchor.y = 1
  node._minAnchor.x = node._minAnchor.y = 0
  node.pivotX = 0
  node.pivotY = 0
  node.left = 0
  node.right = 0
  node.top = 0
  node.bottom = 0
}

export function validateIvData() {
  const gamePlay = getGamePlay()
  const res = []
  const brains = gamePlay.getScript('playsmart.editor.data').$data.brain
  gamePlay.children.forEach((scene, index) => {
    if (!isNormalScene(scene)) return
    const ped = scene.getScript('playsmart.editor.data')
    if (ped.$data.timeline) {
      ped.$data.timeline.forEach((item, trackIndex) => {
        item.segments.forEach((segment, segmentIndex) => {
          const node = nodePool.find(segment.id)
          if (!node) {
            res.push(
              `场景${index}时间轴轨道${trackIndex}元件${segmentIndex}的id:${segment.id}对应的节点不存在`,
            )
          }
          let sceneNode = getSceneNodeByNode(node)
          if (sceneNode && sceneNode.uuid !== scene.uuid) {
            res.push(
              `场景${index}时间轴轨道${trackIndex}元件${segmentIndex}的id:${segment.id}对应的节点不在该场景中`,
            )
          }
          const groupNode = nodePool.find(segment.groupId)
          if (!groupNode) {
            res.push(
              `场景${index}时间轴轨道${trackIndex}元件${segmentIndex}的groupId:${segment.groupId}对应的节点不存在`,
            )
          }
          sceneNode = getSceneNodeByNode(groupNode)
          if (sceneNode && sceneNode.uuid !== scene.uuid) {
            res.push(
              `场景${index}时间轴轨道${trackIndex}元件${segmentIndex}的groupId:${segment.groupId}对应的节点不在该场景中`,
            )
          }
          if (segment.sceneUuid !== scene.uuid) {
            res.push(
              `场景${index}时间轴轨道${trackIndex}元件${segmentIndex}的sceneUuid:${segment.sceneUuid}和该场景id不匹配`,
            )
          }
          if (segment.trackId !== item.id) {
            res.push(
              `场景${index}时间轴轨道${trackIndex}元件${segmentIndex}的trackId:${segment.trackId}和其轨道id:${item.id}不匹配`,
            )
          }
        })
      })
    }
    for (const i in ped.vpAst) {
      for (const j in ped.vpAst[i].condition) {
        if (ped.vpAst[i].condition[j].node) {
          const node = nodePool.find(ped.vpAst[i].condition[j].node)
          if (!node) {
            res.push(
              `场景${index}的事件${i}的条件node:${ped.vpAst[i].condition[j].node}对应的节点不存在`,
            )
          }
          const tSceneNode = getSceneNodeByNode(node)
          if (tSceneNode && tSceneNode.uuid !== scene.uuid) {
            res.push(
              `场景${index}的事件${i}的条件node:${ped.vpAst[i].condition[j].node}对应的节点不在该场景中`,
            )
          }
        }
      }
      for (const j in ped.vpAst[i].action) {
        if (ped.vpAst[i].action[j].node) {
          const node = nodePool.find(ped.vpAst[i].action[j].node)
          if (!node) {
            res.push(
              `场景${index}的事件${i}的响应动作${j}的node:${ped.vpAst[i].action[j].node}对应的节点不存在`,
            )
          }
          const tSceneNode = getSceneNodeByNode(node)
          if (tSceneNode && tSceneNode.uuid !== scene.uuid) {
            res.push(
              `场景${index}的事件${i}的响应动作${j}的node:${ped.vpAst[i].action[j].node}对应的节点不在该场景中`,
            )
          }
        }

        if (ped.vpAst[i].action[j].method === 'vpSwitchScene') {
          const brainItem = brains.find(
            (brain) => brain.sceneUuid === scene.uuid,
          )
          if (!brainItem) {
            res.push(`脑图没有场景${index}，uuid:${scene.uuid}的数据`)
          } else {
            const action = brainItem.actions.some(
              (action) =>
                action.nodeUuid === ped.vpAst[i].action[j].node &&
                action.targetUuid === ped.vpAst[i].action[j].param.jumpSceneId,
            )
            if (!action) {
              res.push(`场景${index}的事件热区跳转场景数据和脑图数据不匹配`)
            }
          }
        }
      }
    }
  })

  brains.forEach((brain, brainIndex) => {
    const node = nodePool.find(brain.sceneUuid)
    if (!node) {
      res.push(
        `脑图${brainIndex}的sceneUuid:${brain.sceneUuid}对应的节点不存在`,
      )
    }
    if (!isNormalScene(node)) {
      res.push(
        `脑图${brainIndex}的sceneUuid:${brain.sceneUuid}对应的节点不是场景节点`,
      )
    }
    if (brain.videoUuid) {
      const videoNode = nodePool.find(brain.videoUuid)
      if (!videoNode) {
        res.push(
          `脑图${brainIndex}的videoUuid:${brain.videoUuid}对应的节点不存在`,
        )
      }
      if (!isVideo(videoNode)) {
        res.push(
          `脑图${brainIndex}的videoUuid:${brain.videoUuid}对应的节点不是视频节点`,
        )
      }
      const tSceneNode = getSceneNodeByNode(videoNode)
      if (tSceneNode && tSceneNode.uuid !== brain.sceneUuid) {
        res.push(
          `脑图${brainIndex}的videoUuid:${brain.videoUuid}对应的节点不在其场景中`,
        )
      }
    }

    const linkNode = nodePool.find(brain.link.id)
    if (!linkNode) {
      res.push(`脑图${brainIndex}的linkId:${brain.link.id}对应的节点不存在`)
    }
    const tSceneNode = getSceneNodeByNode(linkNode)
    if (tSceneNode && tSceneNode.uuid !== brain.sceneUuid) {
      res.push(
        `脑图${brainIndex}linkNode:${brain.link.id}对应的节点不在其场景中`,
      )
    }

    brain.actions.forEach((action, actionIndex) => {
      if (action.nodeUuid) {
        const node = nodePool.find(action.nodeUuid)
        if (!node) {
          res.push(
            `脑图${brainIndex}的action:${actionIndex}的nodeUuid:${action.nodeUuid}对应的节点不存在`,
          )
        }
        const tSceneNode = getSceneNodeByNode(node)
        if (tSceneNode && tSceneNode.uuid !== brain.sceneUuid) {
          res.push(
            `脑图${brainIndex}的action:${actionIndex}的nodeUuid:${action.nodeUuid}对应的节点不在该场景中`,
          )
        }
      }
      if (action.targetUuid) {
        const node = nodePool.find(action.targetUuid)
        if (!node) {
          res.push(
            `脑图${brainIndex}的action:${actionIndex}targetUuid:${action.targetUuid}对应的场景节点不存在`,
          )
        }
        if (!isNormalScene(node)) {
          res.push(
            `脑图${brainIndex}的action:${actionIndex}的nodeUuid:${action.nodeUuid}对应的节点不是场景节点`,
          )
        }
      }
    })
  })
  if (res.length > 0) {
    console.warn(res.join('\n'))
    Message.error(res.join('\n'))
  }
}

export function validateSceneBrain() {
  // 场景和脑图数据校验和兜底处理:如果存在不在脑图中记录的场景节点，就删除该场景节点
  const brainData = store.state.ivBrain.brainData
  const uuids = brainData.map((item: IvBrainItem) => item.sceneUuid)
  const targetUuids: string[] = []
  brainData.forEach((item: IvBrainItem) => {
    const targets = item.actions.map((action) => action.targetUuid)
    targetUuids.push(...targets)
  })
  const sceneToDelete: qc.Node[] = []
  const gamePlay = getGamePlay()
  gamePlay.children.forEach((scene: qc.Node) => {
    if (
      isNormalScene(scene) &&
      uuids.indexOf(scene.uuid) === -1 &&
      targetUuids.indexOf(scene.uuid) === -1
    ) {
      sceneToDelete.push(scene)
    }
  })
  if (sceneToDelete.length > 0) {
    sceneToDelete.forEach((scene) => {
      scene.removeSelf()
    })
  }
}
